import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";
import { Button, Popover, Radio, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const StatusContainer = styled("div")`
  display: flex;
  flex-direction: row;
`;
const StatusButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isPopoverOpen"
})(({ theme, isPopoverOpen }) => ({
  padding: 0,
  minWidth: 0,
  zIndex: 10,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "transparent",
    "& .MuiButton-endIcon": {
      display: "inline-block"
    }
  },
  "& .MuiButton-endIcon": {
    backgroundColor: "#f2f2f2",
    borderRadius: 2,
    width: theme.spacing(2),
    height: theme.spacing(2),
    display: isPopoverOpen ? "inline-block" : "none",
    marginLeft: 3,
    "& > svg": {
      width: theme.spacing(2),
      height: theme.spacing(2)
    }
  }
}));
const ArrowUp = styled(ArrowDropUp)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const ArrowDown = styled(ArrowDropDown)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const StatusPopover = styled(Popover)`
  &&& .MuiPopover-paper {
    display: flex;
    margin-top: ${({ theme }) => theme.spacing(1)};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    min-width: 360px;
    margin-left: ${({ theme }) => theme.spacing(4)};
    padding: ${({ theme }) => theme.spacing(2, 3, 2, 1.5)};
  }
`;
const CancellationRadioWrapper = styled("div")`
  margin-left: ${({ theme }) => theme.spacing(5)};
`;
const CancelationRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.grey[800],
  "&.Mui-checked": {
    color: theme.palette.grey[800]
  }
}));
const RadioTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
const ControlledContainer = styled("div")`
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.spacing(6.25)};
`;
const ControlItem = styled("div")`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
const RoomName = styled(Typography)(({ theme }) => ({
  width: "36px",
  color: theme.palette.grey[800]
}));
export {
  ArrowDown,
  ArrowUp,
  CancelationRadio,
  CancellationRadioWrapper,
  ControlItem,
  ControlledContainer,
  RadioTypography,
  RoomName,
  StatusButton,
  StatusContainer,
  StatusPopover
};
